const reportDeletableDuration = 60 * 60 * 24 * 60;

export { reportDeletableDuration };
